module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    style: ({
      color: _vm.getColor
    })
  }, [_vm._v("\n        " + _vm._s(_vm.mapRow('count')) + "/" + _vm._s(_vm.mapRow('total')) + " (" + _vm._s(_vm.mapRow('percent')) + "%)\n    ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8086a76a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/grid/TotalCountComponent.vue
// module id = 1333
// module chunks = 2